import InputForm from "./InputForm"
import SelectForm from "./SelectForm"
import TextareaForm from "./TextareaForm"
import CheckboxForm from "./CheckboxForm"
import NumberForm from "./NumberForm"
import DateForm from "./DateForm"
import TimeForm from "./TimeForm"
import LinkForm from "./LinkForm"
import RadioForm from "./RadioForm"
import UserForm from "./UserForm"

const TableColumnsRender = (props) => {
    if (!props.inputType) {
        return null
    }

    switch (props.inputType) {
        case 'input':
            return <InputForm {...props} parent="formTable" />
        case 'dropdown':
            return <SelectForm {...props} parent="formTable" />
        case 'textarea':
            return <TextareaForm {...props} parent="formTable" />
        case 'date':
            return <DateForm {...props} parent="formTable" />
        case 'time':
            return (
                <TimeForm
                    {...props}
                    parent="formTable"
                    timeFormat={props.timeFormat}
                    showSeconds={props.showSeconds}
                    use12Hours={props.use12Hours}
                    minuteStep={props.minuteStep}
                    hourStep={props.hourStep}
                />
            )
        case 'number':
            return <NumberForm {...props} parent="formTable" />
        case 'checkbox':
        case 'mcq':
            return <CheckboxForm {...props} parent="formTable" />
        case 'radio':
            return <RadioForm {...props} parent="formTable" />
        case 'link':
            return <LinkForm {...props} parent="formTable" />
        case 'user':
            return <UserForm {...props} parent="formTable" />
        default:
            return <InputForm {...props} parent="formTable" />
    }
}

export default TableColumnsRender
